import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { Observable } from 'rxjs/Observable';
// import { Observable } from 'rxjs';
// import { Router } from '@angular/router';
import { FormControl ,FormGroup, Validators } from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { first } from 'rxjs/operators';
// import {HttpErrorResponse} from '@angular/common/http';
// import {passwordMatchValidator} from '../validators/passwordmatch.validator';
// import swal from 'sweetalert2';
// import swal from 'sweetalert2';

// import { AlertService, AuthenticationService } from '../_services';
import { ServicesService } from '../services/services.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  public login = {'email': '', 'password' : ''};
  loginForm: FormGroup;
  public result;
  isLoginError =  false;
  loading = false;
  submitted = false;
  returnUrl: string;
  isLoader = false;

  constructor(private _services: ServicesService, private router: Router) {}

  ngOnInit() {
    var html = document.getElementsByTagName("html")[0];
    html.classList.add("auth-layout");
    var body = document.getElementsByTagName("body")[0];
    body.classList.add("bg-default");
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    this.loginForm = new FormGroup({
      'name': new FormControl('', [Validators.required]),
      'password': new FormControl('', [Validators.required]),
      'device_token' : new FormControl('1122334455'),
      'device_type': new FormControl('web'),
    });
  }

  loginUser() {
    // //console.log(this.loginForm.value);
    this.isLoader = true;
    this._services.checkLogin(this.loginForm.value).subscribe((data: any) => {
          if(data.status == '200'){
            const userDataJSON = JSON.stringify(data.result);
            // //console.log('user_result', data.result);
            localStorage.setItem('userToken', data.result.token);
            localStorage.setItem('userData', userDataJSON);
            // this._services.rememberToken(data.result.token);
            if(data.result.role_id === 1) {
              this.router.navigate(['clients']);
            } else if(data.result.role_id === 2 || data.result.role_id === 4 || data.result.role_id === 5 || data.result.role_id === 8 || data.result.role_id === 14 || data.result.role_id === 9 || data.result.role_id === 13 || data.result.role_id === 10) {
              this.router.navigate(['loadsheets']);
            } else if(data.result.role_id === 3) {
              this.router.navigate(['orders-list']);
            } else if(data.result.role_id === 6 || data.result.role_id === 7 || data.result.role_id === 11 || data.result.role_id === 12 ) {
              this.router.navigate(['delivery-list']);
            }
              this.isLoader = false;
          }else{
            this.isLoginError = true;
            this.isLoader=false;
          }
        },
        (err: HttpErrorResponse) => {
          this.isLoader = false;
          this.isLoginError = true;
        }
    );

  }
}
